import ChatMenuIcon from './assets/icons/ChatMenuIcon.png'
import ContactIcon from './assets/icons/ContactIcon.png'
import DashboardIcon from './assets/icons/DashboardMenuIcon.png'
import { CImage, CNavItem } from '@coreui/react-pro'

const _nav = [
  {
    component: CNavItem,
    name: 'Chat',
    to: '/chat',
    icon: <CImage fluid src={ChatMenuIcon} className='me-2' />,
    roles: [1, 2]
  },
  {
    component: CNavItem,
    name: 'Contact',
    to: '/contacts',
    icon: <CImage fluid src={ContactIcon} className='me-2' />,
    roles: [1, 2]
  },
  {
    component: CNavItem,
    name: 'Template',
    to: '/template',
    icon: <CImage fluid src={DashboardIcon} className='me-2' />,
    roles: [1, 2]
  }
]

export default _nav
